import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size, rgba } from '../layout/helpers';

export const FullscreenGalleryWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${theme.layers.fullScreenGallery};
  background-color: ${theme.colors.bg.main};
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  height: 100%;
  overflow-x: auto;
`;

export const Item = styled.li`
  height: 100vh;
  padding: ${size(2)};
  display: flex;
  justify-content: center;
  align-items: center;

  & + & {
    border-top: 1px solid ${theme.colors.border.main};
  }
`;

export const ThumbnailWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  padding: ${size(3)};
  overflow: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: ${size(2.25)};
  }

  &::-webkit-scrollbar-track {
    background-color: ${rgba(theme.colors.bg.alt, 0.1)};
    width: ${size(0.25)};
    border-right: ${size(2)} solid transparent;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.bg.alt};
    width: ${size(0.25)};
    border-right: ${size(2)} solid transparent;
    background-clip: padding-box;
  }

  ${theme.screens.LtMd} {
    right: ${size(0.5)};
    padding: ${size(0.5)};
    border-radius: 99px;
    background-color: ${rgba(theme.colors.bg.main, 0.5)};
    backdrop-filter: blur(5px);
  }

  ${theme.screens.Md} {
    right: ${size(3)};
  }
`;

export const ThumbnailList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
`;

export const ThumbnailItem = styled.li`
  & + & {
    margin-top: ${size(0.5)};
  }
`;

export const Thumbnail = styled.button`
  display: block;

  ${theme.screens.LtMd} {
    width: ${size(0.75)};
    height: ${size(0.75)};
    border-radius: 50%;
    background-color: ${theme.colors.bg.alt};
    opacity: 0.2;
    transition: opacity 150ms ease;

    &.is-active {
      opacity: 1;
    }

    > * {
      display: none;
    }
  }

  ${theme.screens.Md} {
    width: ${size(8)};
    height: ${size(8)};
    padding: ${size(1)};
    border: 1px solid ${theme.colors.border.main};
    border-radius: 4px;
    background-color: ${theme.colors.bg.main};
    transform-origin: 50% 50%;
    transition:
      transform 200ms ease,
      border-color 75ms ease;

    &.is-active {
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background-color: ${theme.colors.border.active};
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }

    &:hover {
      border-color: ${theme.colors.border.hover};
    }

    &:active {
      transform: scale(0.97);
    }
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: ${size(1)};
  right: ${size(1)};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size(4)};
  height: ${size(4)};
  border-radius: 50%;
  background-color: ${theme.colors.bg.main};
  border: 1px solid ${theme.colors.border.main};
  transform-origin: 50% 50%;
  transition:
    transform 200ms ease,
    border-color 75ms ease;

  &:hover {
    border-color: ${theme.colors.border.hover};
  }

  &:active {
    transform: scale(0.95);
  }

  ${theme.screens.Md} {
    width: ${size(6)};
    height: ${size(6)};
    top: ${size(3)};
    right: ${size(3)};
  }
`;
